<template>
    <div id="closet" class="info">
        <div v-if="closet">
            <el-row v-for="cl in closet.closetInfo" :gutter="5" style="margin-bottom: 2rem;">
                <el-col :span="24">
                    <h2>{{ cl[0].age + '-' + cl[0].name }}</h2>
                </el-col>
                <el-col :span="24" style="color:slategray;margin-bottom: 1rem;">{{ cl[0].description }}</el-col>
                <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8" v-for="item in cl">
                    <el-card shadow="hover" :body-style="{ padding: '0px' }">
                        <el-image shadow="hover" style="width: 100%"
                            :src="'http://helloworldend.top/closet/' + item.image" :zoom-rate="1.2" :max-scale="7"
                            :min-scale="0.2" :preview-src-list="closet.gallery" show-progress
                            :initial-index="Number(item.sort) - 1" fit="cover" />
                    </el-card>
                </el-col>
                <el-col :span="24" style="height: 1rem;"></el-col>
                <!-- <el-col :span="24" style="margin-bottom: 1rem;"
                    v-if="cl[0].gallery !== undefined && cl[0].gallery.length > 0">
                    <el-collapse v-model="activeNames" @change="handleChange">
                        <el-collapse-item name="1">
                            <template #title>
                                <div class="custom-title">关联稿件</div>
                            </template>
<el-row>
    <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6" v-for="g, index in cl[0].gallery_t">
        <el-card shadow="hover" :body-style="{ padding: '0px' }" v-if="g.includes(cl[0].code + '-' + cl[0].name)">
            <el-image shadow="hover" style="width: 100%" :src="g" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
                :preview-src-list="cl[0].gallery" show-progress :initial-index="index" fit="cover" />
        </el-card>
    </el-col>
</el-row>
</el-collapse-item>
</el-collapse>
</el-col> -->
            </el-row>
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import service from '../utils/request'

let route = useRoute()
const title = route.params.name[0]
const closet = ref()

const getData = (name) => {
    const params = {
        name: name
    };
    service.get("/user/closet/listCloset", { params })
        .then(res => {
            const rst = res.data;
            if (rst.length != 0 && rst[0] != null) {
                for (let i = 0; i < rst.length; i++) {
                    const images = Object.values(require.context("img", true, /.*/).keys());
                    for (let j = 0; j < images.length; j++) {
                        if (images[j].includes(rst[i].image)) {
                            let q = images[j].replace(/^.\//, '');
                            rst[i].image = require(`img/${q}`);
                        }
                    }
                }
                rst.sort((a, b) => a.sort - b.sort);
                const gallery = rst.map(item => 'http://img.helloworldend.top/closet/' + item.image);
                const closetInfo = {};
                rst.forEach(item => {
                    const name = item.age + item.name;
                    if (!closetInfo[name]) {
                        closetInfo[name] = [];
                    }
                    closetInfo[name].push(item);
                });
                closet.value = { closetInfo: closetInfo, gallery: gallery };
            } else {
                console.error('返回服设信息为空', error);
            }
        }).catch(error => {
            console.error('获取服设信息失败', error);
        });
}

onMounted(() => {
    getData(title)
})


</script>
<style scoped>
h2 {
    padding: 0;
    margin-bottom: 1rem
}

.custom-title {
    font-size: 1.25rem;
    /* 更多自定义样式 */
}
</style>